'use strict';


define('InternationalPhoneView', ['backbone', 'NVTagCallbacks', 'FieldView', 'placeholder', 'loadScript', 'assetUrl', 'intl-tel-input'],
  function (Backbone, invokeCallbacks, FieldView, placeholder, loadScript, assetUrl) {
    var utilsUrl = assetUrl('js/intl-tel.input.utils.js');

    function loadUtils() {
      // don't load utils twice
      if (window.intlTelInputUtils) {
        return;
      }

      // dynamic loading of JS doesn't work properly using the AT debugger
      // so dynamically load it with requirejs here.
      // dynamically loading with requirejs doesn't work in prod because
      // we optimize with almond which doesn't support loading modules dynamically
      if (!window.nvtagDebug) {
        loadScript(utilsUrl);
      } else {
        try {
          require([utilsUrl], function () { });
        } catch (error) {
          console.debug('error loading intl-phone-utils in debug mode');
        }
      }
    }

    return FieldView.extend({
      __name__: 'InternationalPhoneView',
      tagName: 'label',
      type: 'international_phone',
      events: {
        'change': 'renderFeedback'
      },
      className: function () {
        return 'at-text   ' + this.options.definition.name;
      },
      multiple_fields: function () {
        return [this.name, this.name + 'CountryCode'];
      },
      initialize: function () {
        // for now, forms only has us clients, so the database code will be us.
        // if/when non-us clients get digital the database country will need to be fetched dynamically
        this.databaseCountryCode = 'us';

        FieldView.prototype.initialize.call(this);
        this.controlClass = '.intl-phone-' + this.name;
        Backbone.$().ready(loadUtils);
      },
      context: function () {
        var context = {
          name: this.name,
          label: this.def.label || this.title,
          title: this.title,
          required: this.def.required && 'required',
          value: this.def.default_value || '',
          type: this.def.type,
          labelhide: this.options.labels === 'placeholder'
        };
        if (context.labelhide){
          context.placeholder = 'placeholder="' + _.escape(this.title) + (context.required ? '*' : '') + '"';
        }
        return invokeCallbacks('alterContext', { element: this.type, context: context, def: this.def }).context;
      },
      render: function () {
        var context = this.context();
        var metadata = this.options.formview.options.form_definition.metadata;
        //object {'iso_code': 'display_name'} formatted for lib to use for translations
        var countries = (this.def.options || []).reduce(function(obj, item) {
          obj[item.value.toLowerCase()] = item.display;
          return obj;
        }, {});
        this.$el.html(this.template(context));
        this.$input = this.$el.find(this.controlClass);
        this.intlTelInstance = window.intlTelInput(this.$input[0], {
          initialCountry: this.databaseCountryCode,
          nationalMode: true,
          numberType: 'MOBILE',
          preferredCountries: (metadata && metadata.languageCode) ? [] : ['us', 'gb', 'ca'],
          dropdownContainer: document.body,
          autoPlaceholder: 'off',
          originalCountryCode: this.databaseCountryCode,
          localizedCountries: countries,
          onlyCountries: Object.keys(countries)
        });

        // map default values from smartlinks, etc to control
        this.$input.val(this.def.default_value || '');
        this.intlTelInstance.setCountry(this.def.default_country_code || this.databaseCountryCode);
        
        this.$input.on('countrychange', this.renderFeedback);
      },
      renderFeedback: function () {
        if (!window.intlTelInputUtils) {
          return this.renderFeedbackWithErrors(this.errors());
        }
        var baseNumber = this.getNumberOnly();
        if (baseNumber) {
          var countryCode = this.intlTelInstance.getSelectedCountryData().iso2;
          if (this.name === 'WorkPhone' && this.intlTelInstance.getExtension()) {
            var ext = this.intlTelInstance.getExtension();

            // validate and display base number as you would without an extension, then tack the extension back on at the end
            var formattedNum = window.intlTelInputUtils.formatNumber(baseNumber, countryCode, window.intlTelInputUtils.numberFormat.NATIONAL);
            this.$input.val(formattedNum + ' x' + ext);

          } else if (this.intlTelInstance.isValidNumber()) {
            // causes the displayed number to get formatted since autoformat is not supported anymore
            // https://github.com/jackocnr/intl-tel-input/issues/346
            this.$input.val(window.intlTelInputUtils.formatNumber(baseNumber, countryCode, window.intlTelInputUtils.numberFormat.NATIONAL));
          }
        }
        return this.renderFeedbackWithErrors(this.errors());
      },
      errors: function () {
        if (!window.intlTelInputUtils) {
          return [];
        }
        var errors = !this.require_valid() ? [this.resources.fill(this.resources.PrimaryResources.BlankIsRequired, this.title)] : [];
        if (this.getNumberOnly() && !this.intlTelInstance.isValidNumber()) {
          errors.push(this.resources.fill(this.resources.PrimaryResources.PleaseEnterValidBlank, this.title));
        }

        errors = _.map(invokeCallbacks('alterErrors', {
          val: this.getNumberOnly(),
          field_name: this.field_name(),
          errors: errors,
          def: this.def
        }).errors, this.toError, this);
        return errors;
      },
      getFullNumber: function () {
        var number;
        if (window.intlTelInputUtils) {
          number = this.intlTelInstance.getNumber(window.intlTelInputUtils.numberFormat.NATIONAL);
        } else {
          number = Backbone.$(this.controlClass).val();
        }
        if (this.name === 'WorkPhone' && this.intlTelInstance.getExtension()) {
          number = number + ' x' + this.intlTelInstance.getExtension();
        }
        return number.replace(/\D/g, '');
      },
      getNumberOnly: function () {
        var number;
        if (window.intlTelInputUtils) {
          number = this.intlTelInstance.getNumber(window.intlTelInputUtils.numberFormat.NATIONAL);
          if (this.name === 'WorkPhone' && this.intlTelInstance.getExtension()) {
            var ext = this.intlTelInstance.getExtension();
            // get phone number without extension
            number = number.substr(0, number.length - ext.length);
          }
        } else {
          number = Backbone.$(this.controlClass).val();
        }
        return number.replace(/\D/g, '');
      },
      val: function () {
        var phoneType = this.context().name;
        var countryData = this.intlTelInstance.getSelectedCountryData();

        var toReturn = {};
        toReturn[phoneType] = this.getNumberOnly();
        if (!toReturn[phoneType]) {
          return null;
        }
        toReturn[phoneType + 'CountryCode'] = countryData.iso2;
        toReturn[phoneType + 'InternationalDialingPrefix'] = countryData.dialCode;
        if (phoneType === 'WorkPhone') {
          toReturn.WorkPhoneExtension = this.intlTelInstance.getExtension();
        }
        return toReturn;
      },
      setval: function (value) {
        var phoneType = this.context().name;
        var typeCountryCode = phoneType + 'CountryCode';
        if (_.isNull(value)) {
          return this;
        }
        if (!_.isNull(value[phoneType]) && !_.isUndefined(value[phoneType])) {
          this.$input.val(value[phoneType]);
        } else {
          this.$input.val('');
        }
        if (!_.isNull(value[typeCountryCode]) && !_.isUndefined(value[typeCountryCode])) {
          this.intlTelInstance.setCountry(value[typeCountryCode]);
        }
        return this.touch().hideOrShow();
      },
    });
  });

